/**
 * Do not edit directly — generated by `pnpm build-tokens`.
 */

export type Env0Theme = {
  mode: 'light' | 'dark';
  primaryWhite: string;
  offWhite: string;
  whiteColor: string;
  primaryBlack: string;
  secondaryBlack: string;
  primaryGray: string;
  secondaryGray: string;
  tertiaryGray: string;
  lightGray: string;
  subtitleGray: string;
  sidebarHoverGray: string;
  backgroundGray: string;
  lighterBackgroundGray: string;
  textBaseGray: string;
  textGray: string;
  plainGray: string;
  darkGray: string;
  nonEditableBorderGray: string;
  nonEditableBackgroundGray: string;
  separatorGray: string;
  tableHeaderLineGray: string;
  secondaryDisabledGray: string;
  primaryDisabledGray: string;
  iconGrayBackground: string;
  iconGrayFill: string;
  menuGray: string;
  menuGrayLight: string;
  modalMaskGray: string;
  subtitleDarkBlue: string;
  primaryBlue: string;
  darkBlue: string;
  lightBlue: string;
  lighterBlue: string;
  littleBlue: string;
  lightBackgroundBlue: string;
  limeYellow: string;
  limeYellowActive: string;
  oliveGreen: string;
  matchGreen: string;
  skyBlue: string;
  lighterSkyBlue: string;
  backgroundLightBlue: string;
  drawerHeaderBlue: string;
  tealBlue: string;
  deepTeal: string;
  secondaryGreen: string;
  widgetGreen: string;
  lightGreen: string;
  backgroundGreen: string;
  labelGreen: string;
  green: string;
  brandGreen: string;
  brandGreenBackground: string;
  errorRed: string;
  errorRedHover: string;
  red: string;
  lightRed: string;
  antdAlertRed: string;
  warningYellowDarker: string;
  alertYellow: string;
  vividYellow: string;
  lightPurple: string;
  brightPurple: string;
  sideMenuBackground: string;
  sideMenuBorder: string;
  sideMenuText: string;
  sideMenuItemSelected: string;
  primaryDisabledBorder: string;
  markdownBackground: string;
  lineGraphBackground: string;
  deploymentTypeIconBackground: string;
  kbarSectionBackground: string;
  billingWrapperBackground: string;
  usageCardBackground: string;
  variableCounterBackground: string;
  tooltipBackground: string;
  backdrop: string;
  innerLayoutContentBackground: string;
  textMetalBlue: string;
  textColor: string;
  textColorInvert: string;
  dividerText: string;
  menuItemText: string;
  variableTitle: string;
  tooltipLink: string;
  deploymentLogDescriptionInfoText: string;
  deploymentLogDescriptionErrorText: string;
  deploymentLogDescriptionSuccessText: string;
  deploymentLogDescriptionWarningText: string;
  inputDisabled: string;
  errorChipBackground: string;
  errorChipText: string;
  warningChipBackground: string;
  warningChipText: string;
  successChipBackground: string;
  successChipText: string;
  statusButtonLightRed: string;
  statusButtonGray: string;
  statusButtonYellow: string;
  statusButtonRedText: string;
  statusButtonDarkGrayText: string;
  statusButtonAlertYellowText: string;
  whiteStatusButtonText: string;
  orgSettingsBillingborder: string;
  secondaryHover: string;
  primaryDisabledText: string;
  iconBackground: string;
  deploymentStepLogBackground: string;
  deploymentStepBackground: string;
  popoverTreeSelectorHover: string;
  menuBorder: string;
  navbarText: string;
  lableBackgroundGray: string;
  lableColorGray: string;
  logoutGray: string;
  menuItemBlue: string;
  menuItemBlueActive: string;
  markdownHeaderBlue: string;
  menuItemGreen: string;
  deleteHoverRed: string;
  warningYellow: string;
  alertYellowText: string;
  cyan: string;
  sideMenuBackgroundDark: string;
  sidebarBorder: string;
  sidebarSecondaryBorder: string;
  inputDisabledBorder: string;
  loginPageBottomPart: string;
  onboardingBackground: string;
  workflowBackground: string;
  workflowBackgroundLighter: string;
  drawerBackground: string;
  scrollbarThumbBackground: string;
  scrollbarTrackBackground: string;
  deploymentLogDescriptionBackground: string;
  tooltipText: string;
  loginBackground: string;
  statusButtonGreen: string;
  statusButtonPurple: string;
  statusButtonRed: string;
  statusButtonWhiteText: string;
  statusButtonSecondaryGreenText: string;
  statusButtonPrimaryBlueText: string;
  counterBadgeText: string;
  counterBadgeActiveText: string;
  datepickerText: string;
  defaultShadow: string;
  defaultBorderRadius: string;
};

export const env0Themes = {
  light: {
    mode: "light",
    primaryWhite: "#ffffff",
    offWhite: "#ffffff",
    whiteColor: "#d9d9d9",
    primaryBlack: "#222423",
    secondaryBlack: "#222423",
    primaryGray: "#f3f5f7",
    secondaryGray: "#d9d9d9",
    tertiaryGray: "#222423",
    lightGray: "#d9d9d9",
    subtitleGray: "#4d4d4d",
    sidebarHoverGray: "#e6e6e6",
    backgroundGray: "#222423",
    lighterBackgroundGray: "#ffffff",
    textBaseGray: "#0c0c0b",
    textGray: "#4d4d4d",
    plainGray: "#f3f5f7",
    darkGray: "#222423",
    nonEditableBorderGray: "#d9d9d9",
    nonEditableBackgroundGray: "#f3f5f7",
    separatorGray: "#f3f5f7",
    tableHeaderLineGray: "#f3f5f7",
    secondaryDisabledGray: "#767676",
    primaryDisabledGray: "#d9d9d9",
    iconGrayBackground: "#d9d9d9",
    iconGrayFill: "#d9d9d9",
    menuGray: "#f3f5f7",
    menuGrayLight: "#f3f5f7",
    modalMaskGray: "#0c0c0b",
    subtitleDarkBlue: "#3651d8",
    primaryBlue: "#722ed1",
    darkBlue: "#2c42af",
    lightBlue: "#ebeefb",
    lighterBlue: "#2c42af",
    littleBlue: "#3651d8",
    lightBackgroundBlue: "#ebeefb",
    limeYellow: "#d2f740",
    limeYellowActive: "#b3d049",
    oliveGreen: "#488700",
    matchGreen: "#488700",
    skyBlue: "#9aa7eb",
    lighterSkyBlue: "#edf0f3",
    backgroundLightBlue: "#fafafa",
    drawerHeaderBlue: "#f9f0ff",
    tealBlue: "#0f9595",
    deepTeal: "#0f9595",
    secondaryGreen: "#0f9595",
    widgetGreen: "#a3c380",
    lightGreen: "#e6fffb",
    backgroundGreen: "rgba(21, 21, 20, 0.4)",
    labelGreen: "#0f9595",
    green: "#488700",
    brandGreen: "#b3d049",
    brandGreenBackground: "#fafeec",
    errorRed: "#ef5360",
    errorRedHover: "#ef5360",
    red: "#ef5360",
    lightRed: "#fdf4e7",
    antdAlertRed: "#fdeeef",
    warningYellowDarker: "#e8930c",
    alertYellow: "#f4fdcf",
    vividYellow: "#e8930c",
    lightPurple: "#f9f0ff",
    brightPurple: "#3651d8",
    sideMenuBackground: "#ffffff",
    sideMenuBorder: "#f3f5f7",
    sideMenuText: "#0c0c0b",
    sideMenuItemSelected: "#e6e6e6",
    primaryDisabledBorder: "#808080",
    markdownBackground: "#fafafa",
    lineGraphBackground: "#fafafa",
    deploymentTypeIconBackground: "#222423",
    kbarSectionBackground: "#ffffff",
    billingWrapperBackground: "#fafafa",
    usageCardBackground: "#f3f5f7",
    variableCounterBackground: "#ebeefb",
    tooltipBackground: "#222423",
    backdrop: "#222423",
    innerLayoutContentBackground: "#fafafa",
    textMetalBlue: "#808080",
    textColor: "#222423",
    textColorInvert: "#d9d9d9",
    dividerText: "#808080",
    menuItemText: "#4d4d4d",
    variableTitle: "#767676",
    tooltipLink: "#87e8de",
    deploymentLogDescriptionInfoText: "#d9d9d9",
    deploymentLogDescriptionErrorText: "#f7a9af",
    deploymentLogDescriptionSuccessText: "#a3c380",
    deploymentLogDescriptionWarningText: "#f3c985",
    inputDisabled: "#767676",
    errorChipBackground: "#fdf4e7",
    errorChipText: "#bf4550",
    warningChipBackground: "#f4fdcf",
    warningChipText: "#b37109",
    successChipBackground: "#fafeec",
    successChipText: "#488700",
    statusButtonLightRed: "#f7a9af",
    statusButtonGray: "#edf0f3",
    statusButtonYellow: "#f3c985",
    statusButtonRedText: "#222423",
    statusButtonDarkGrayText: "#222423",
    statusButtonAlertYellowText: "#222423",
    whiteStatusButtonText: "#d9d9d9",
    orgSettingsBillingborder: "#f3f5f7",
    secondaryHover: "#fafafa",
    primaryDisabledText: "#ffffff",
    iconBackground: "#d9d9d9",
    deploymentStepLogBackground: "#0c0c0b",
    deploymentStepBackground: "#d9d9d9",
    popoverTreeSelectorHover: "#d9d9d9",
    menuBorder: "#e6e6e6",
    navbarText: "#d9d9d9",
    lableBackgroundGray: "#d9d9d9",
    lableColorGray: "#9aa7eb",
    logoutGray: "#808080",
    menuItemBlue: "#222423",
    menuItemBlueActive: "#222423",
    markdownHeaderBlue: "#3651d8",
    menuItemGreen: "#87e8de",
    deleteHoverRed: "#ef5360",
    warningYellow: "#f4fdcf",
    alertYellowText: "#b37109",
    cyan: "#87e8de",
    sideMenuBackgroundDark: "#0c0c0b",
    sidebarBorder: "#222423",
    sidebarSecondaryBorder: "#151514",
    inputDisabledBorder: "#d9d9d9",
    loginPageBottomPart: "#0c0c0b",
    onboardingBackground: "#222423",
    workflowBackground: "#2c42af",
    workflowBackgroundLighter: "#2c42af",
    drawerBackground: "#fafafa",
    scrollbarThumbBackground: "#d9d9d9",
    scrollbarTrackBackground: "#ffffff",
    deploymentLogDescriptionBackground: "#222423",
    tooltipText: "#ffffff",
    loginBackground: "#fafafa",
    statusButtonGreen: "#f4fdcf",
    statusButtonPurple: "#f9f0ff",
    statusButtonRed: "#ef5360",
    statusButtonWhiteText: "#fafafa",
    statusButtonSecondaryGreenText: "#f3f5f7",
    statusButtonPrimaryBlueText: "#3651d8",
    counterBadgeText: "#d9d9d9",
    counterBadgeActiveText: "#3651d8",
    datepickerText: "#d9d9d9",
    defaultShadow: "-1px 6px 30px 0 rgba(204, 204, 204, 0.5)",
    defaultBorderRadius: "4px"
  },
  dark: {
    mode: "dark",
    primaryWhite: "#151514",
    offWhite: "#151514",
    whiteColor: "#d9d9d9",
    primaryBlack: "#fafafa",
    secondaryBlack: "#222423",
    primaryGray: "#222423",
    secondaryGray: "#4d4d4d",
    tertiaryGray: "#222423",
    lightGray: "#4d4d4d",
    subtitleGray: "#edf0f3",
    sidebarHoverGray: "#4d4d4d",
    backgroundGray: "#222423",
    lighterBackgroundGray: "#151514",
    textBaseGray: "#ffffff",
    textGray: "#edf0f3",
    plainGray: "#222423",
    darkGray: "#222423",
    nonEditableBorderGray: "#4d4d4d",
    nonEditableBackgroundGray: "#222423",
    separatorGray: "#222423",
    tableHeaderLineGray: "#222423",
    secondaryDisabledGray: "#808080",
    primaryDisabledGray: "#4d4d4d",
    iconGrayBackground: "#d9d9d9",
    iconGrayFill: "#d9d9d9",
    menuGray: "#222423",
    menuGrayLight: "#222423",
    modalMaskGray: "#0c0c0b",
    subtitleDarkBlue: "#687ce2",
    primaryBlue: "#b97df2",
    darkBlue: "#2c42af",
    lightBlue: "#050816",
    lighterBlue: "#2c42af",
    littleBlue: "#3651d8",
    lightBackgroundBlue: "#050816",
    limeYellow: "#d2f740",
    limeYellowActive: "#b3d049",
    oliveGreen: "#76a540",
    matchGreen: "#76a540",
    skyBlue: "#9aa7eb",
    lighterSkyBlue: "#4d4d4d",
    backgroundLightBlue: "#222423",
    drawerHeaderBlue: "#11071f",
    tealBlue: "#13c2c2",
    deepTeal: "#13c2c2",
    secondaryGreen: "#13c2c2",
    widgetGreen: "#a3c380",
    lightGreen: "#021616",
    backgroundGreen: "rgba(21, 21, 20, 0.4)",
    labelGreen: "#13c2c2",
    green: "#76a540",
    brandGreen: "#b3d049",
    brandGreenBackground: "#151906",
    errorRed: "#ef5360",
    errorRedHover: "#ef5360",
    red: "#ef5360",
    lightRed: "#2d160a",
    antdAlertRed: "#18080a",
    warningYellowDarker: "#e8930c",
    alertYellow: "#343e10",
    vividYellow: "#e8930c",
    lightPurple: "#11071f",
    brightPurple: "#3651d8",
    sideMenuBackground: "#151514",
    sideMenuBorder: "#222423",
    sideMenuText: "#ffffff",
    sideMenuItemSelected: "#4d4d4d",
    primaryDisabledBorder: "#808080",
    markdownBackground: "#222423",
    lineGraphBackground: "#222423",
    deploymentTypeIconBackground: "#fafafa",
    kbarSectionBackground: "#151514",
    billingWrapperBackground: "#222423",
    usageCardBackground: "#222423",
    variableCounterBackground: "#050816",
    tooltipBackground: "#fafafa",
    backdrop: "#222423",
    innerLayoutContentBackground: "#222423",
    textMetalBlue: "#808080",
    textColor: "#fafafa",
    textColorInvert: "#d9d9d9",
    dividerText: "#808080",
    menuItemText: "#edf0f3",
    variableTitle: "#808080",
    tooltipLink: "#87e8de",
    deploymentLogDescriptionInfoText: "#d9d9d9",
    deploymentLogDescriptionErrorText: "#f7a9af",
    deploymentLogDescriptionSuccessText: "#a3c380",
    deploymentLogDescriptionWarningText: "#f3c985",
    inputDisabled: "#808080",
    errorChipBackground: "#2d160a",
    errorChipText: "#bf4550",
    warningChipBackground: "#343e10",
    warningChipText: "#b37109",
    successChipBackground: "#151906",
    successChipText: "#76a540",
    statusButtonLightRed: "#f7a9af",
    statusButtonGray: "#4d4d4d",
    statusButtonYellow: "#f3c985",
    statusButtonRedText: "#222423",
    statusButtonDarkGrayText: "#222423",
    statusButtonAlertYellowText: "#222423",
    whiteStatusButtonText: "#d9d9d9",
    orgSettingsBillingborder: "#222423",
    secondaryHover: "#222423",
    primaryDisabledText: "#4d4d4d",
    iconBackground: "#d9d9d9",
    deploymentStepLogBackground: "#0c0c0b",
    deploymentStepBackground: "#151514",
    popoverTreeSelectorHover: "#4d4d4d",
    menuBorder: "#808080",
    navbarText: "#d9d9d9",
    lableBackgroundGray: "#4d4d4d",
    lableColorGray: "#9aa7eb",
    logoutGray: "#808080",
    menuItemBlue: "#222423",
    menuItemBlueActive: "#222423",
    markdownHeaderBlue: "#687ce2",
    menuItemGreen: "#87e8de",
    deleteHoverRed: "#ef5360",
    warningYellow: "#343e10",
    alertYellowText: "#b37109",
    cyan: "#87e8de",
    sideMenuBackgroundDark: "#0c0c0b",
    sidebarBorder: "#222423",
    sidebarSecondaryBorder: "#151514",
    inputDisabledBorder: "#4d4d4d",
    loginPageBottomPart: "#0c0c0b",
    onboardingBackground: "#222423",
    workflowBackground: "#2c42af",
    workflowBackgroundLighter: "#2c42af",
    drawerBackground: "#222423",
    scrollbarThumbBackground: "#151514",
    scrollbarTrackBackground: "#4d4d4d",
    deploymentLogDescriptionBackground: "#222423",
    tooltipText: "#151514",
    loginBackground: "#222423",
    statusButtonGreen: "#343e10",
    statusButtonPurple: "#11071f",
    statusButtonRed: "#ef5360",
    statusButtonWhiteText: "#222423",
    statusButtonSecondaryGreenText: "#222423",
    statusButtonPrimaryBlueText: "#687ce2",
    counterBadgeText: "#4d4d4d",
    counterBadgeActiveText: "#687ce2",
    datepickerText: "#4d4d4d",
    defaultShadow: "0 12px 30px rgba(29, 19, 109, 0.12)",
    defaultBorderRadius: "4px"
  }
} satisfies Record<"light" | "dark", Env0Theme>;

export type Env0ThemeMode = keyof typeof env0Themes;

export const getEnv0Theme = (mode: Env0ThemeMode): Env0Theme => env0Themes[mode];

export default env0Themes;
